
import { INSTALLED, UNINSTALLED } from '@/constants/objectStatuses'

export const getObjectStates = (href) => {
  if ( href.includes('alarms') ) {
    return [INSTALLED, UNINSTALLED]
  }
  return []
}